<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
    >
      <v-text-field
          single-line
          outlined
          dense
          clearable
          :disabled="isLoading"
          v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
      </v-text-field>
      <v-select
          v-if="$vuetify.breakpoint.smAndUp"
          v-model="pagination.filters.is_in_blacklist"
          label="Ограничения"
          class="pt-7 pl-2"
          outlined
          dense
          style="padding-bottom: 2px"
          single-line
          flat
          clearable
          :disabled="isLoading"
          :items="selectors.is_in_blacklist"
      ></v-select>
      <v-spacer></v-spacer>
      <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          class="mr-0 dark-primary"
          @click="newVisitor"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          class="mr-0 dark-primary"
          @click="show = !show"
      >
        <v-icon>{{ show ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
      <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
        <v-btn
            text
            @click="newVisitor"
            class="dark-primary rounded-tr-lg"
        >
          Добавить посетителя
        </v-btn>

      </v-toolbar-items>
    </v-toolbar>
    <v-slide-y-transition>
      <v-toolbar color="#DADADA" v-if="show && $vuetify.breakpoint.xsOnly" elevation="0">
        <v-row no-gutters>
          <v-col>
            <v-select
                v-model="pagination.filters.is_in_blacklist"
                label="Ограничения"
                class="pt-6"
                outlined
                dense
                style="padding-bottom: 2px"
                single-line
                flat
                clearable
                :disabled="isLoading"
                :items="selectors.is_in_blacklist"
            ></v-select>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-slide-y-transition>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        multi-sort
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.last_name="props">
        <span style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">{{props.item.last_name}}</span>
      </template>
      <template v-slot:item.is_foreigner="{ item }">
        <v-icon
            :color="checkFlag(item.is_foreigner).color"
        >
          {{checkFlag(item.is_foreigner).icon}}
        </v-icon>
      </template>
      <template v-slot:item.is_in_blacklist="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                :color="checkBlackListFlag(item.is_in_blacklist).color"
                dark
                v-bind="attrs"
                v-on="on"
            >
              {{checkBlackListFlag(item.is_in_blacklist).icon}}
            </v-icon>
          </template>
          <span>{{checkBlackListFlag(item.is_in_blacklist).text}}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="editVisitor(item)"
                v-bind="attrs"
                v-on="on"
            >
              edit
            </v-icon>
          </template>
          <span>Редактировать посетителя</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="deleteVisitor(item)"
                v-bind="attrs"
                v-on="on"
            >
              delete
            </v-icon>
          </template>
          <span>Удалить посетителя</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="updateData"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
    <VisitorsEditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :visitor-data="visitors_data"
        @close="closeEditDialog"
    ></VisitorsEditDialog>
    <VisitorsDeleteDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :visitor-data="visitors_data"
        @close="closeDeleteDialog"
    ></VisitorsDeleteDialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import VisitorsEditDialog from "../components/VisitorsEditDialog";
import VisitorsDeleteDialog from "../components/VisitorsDeleteDialog";
import names from "@/modules/admin/routers/names";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";

export default {
  name: "AdminVisitorsList",
  components: {VisitorsEditDialog, VisitorsDeleteDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список посетителей",
      show: false,
      dialog_add_edit: false,
      dialog_delete: false,
      visitors_data: undefined,
      edit_status: undefined,
      search: {
        parameter: "search"
      },
      pagination: {
        filters: {
          "is_in_blacklist": null
        }
      },
      selectors: {
        is_in_blacklist: [
          {text: "В черном списке", value: true},
          {text: "В сером списке", value: "null"}
        ]
      },
      headers: [
        {text: "Фамилия", value: "last_name", sortable: true, align: "start", width: "20%"},
        {text: "Имя", value: "first_name", sortable: true, align: "start", width: "15%"},
        {text: "Отчество", value: "middle_name", sortable: true, align: "start", width: "15%"},
        {text: "Организация", value: "organization", sortable: true, align: "start", width: "20%"},
        {text: "Иностранный гражданин", value: "is_foreigner", sortable: false, align: "center", width: "10%"},
        {text: "Ограничения", value: "is_in_blacklist", sortable: false, align: "center", width: "10%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "10%"}
      ]
    }
  },
  computed:{
    ...mapGetters({
      items: "admin/getVisitorsList",
      count: "admin/getVisitorsCount",
      isLoading: "admin/isLoadingVisitors",
      getCurrentUrl: "admin/getVisitorsCurrentUrl"
    })
  },
  methods: {
    ...mapActions({
      loadVisitorsList: "admin/loadVisitorsList"
    }),
    updateData(){
      if (this.search.value) {
        this.search.value = ""
      }
      this.pagination.filters = {
        "is_in_blacklist": null
      }
      this.loadData()
    },
    loadData(url=undefined){
      this.loadVisitorsList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          if (this.pagination.filters.is_in_blacklist)
            new_url = this.addGetParameter(new_url, "is_in_blacklist", this.pagination.filters.is_in_blacklist)
          return new_url
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    getDetail(item) {
      this.$router.push({name: names.VISITORS.DETAIL, params: {idVisitors: item.id}}).catch(() => {})
    },
    newVisitor() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.visitors_data = undefined
    },
    editVisitor(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.visitors_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.visitors_data = undefined
    },
    deleteVisitor(item) {
      this.dialog_delete = true
      this.visitors_data = item.id
    },
    closeDeleteDialog(event) {
      this.loadData()
      this.dialog_delete = false
      this.visitors_data = undefined
    },
    checkFlag(flag) {
      if (flag) return {icon: "check_circle", color: "green"}
      else return {icon: "radio_button_unchecked", color: "grey"}
    },
    checkBlackListFlag(flag) {
      if (flag === true) return {icon: "do_not_disturb_on", color: "red", text: "Пользователь в черном списке"}
      else if (flag === false) return {icon: "radio_button_unchecked", color: "grey", text: "Ограничений нет"}
      else return {icon: "error", color: "yellow darken-2", text: "Пользователь в сером списке"}
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
